import * as Yup from 'yup'
import { AuthPasswordValidationSchema } from "../../../auth"

export interface ICreateAccount {
    companyName: string, 
    companyOverseas: boolean,
    companyRegistration: string, 
    companyAddress: string,
    companyTelephone: string, 
    companyFax: string,
    companyWebsite: string,
    adminName: string, 
    adminDesignation: string, 
    adminContact: string, 
    adminEmail: string,
    adminPassword: string, 
    adminPasswordConfirm: string,
}

const createAccountSchemas = [
    Yup.object({
        companyName: Yup.string().trim().required().label('Company Name'),
        companyOverseas: Yup.boolean().label('Company Overseas'),
        companyRegistration: Yup.string().trim().label('Company Registration')
        .when("companyOverseas", {
            is: false,
            then: (schema) => schema.required()
        }),        
        companyAddress: Yup.string().trim().required().label('Address'),
        companyTelephone: Yup.string().trim().required().label('Telephone'),
        companyFax: Yup.string().trim().label('Fax'),
        companyWebsite: Yup.string().trim().label('Website'),
    }),
    Yup.object({
        adminName: Yup.string().trim().required().label('Name'),
        adminDesignation: Yup.string().trim().required().label('Designation'),
        adminContact: Yup.string().trim().required().label('Contact'),
        adminEmail: Yup.string().trim().required()
            .email('Must be a valid email address')
            .min(3, 'Minimum 3 symbols')
            .max(200)
            .label('Email/Login Name'),
        adminPassword: AuthPasswordValidationSchema.required('Password Required'),
        adminPasswordConfirm: Yup.string().trim().required()
        .when('adminPassword', {
            is: (val: string) => (val && val.length > 0 ? true : false),
            then: (schema) => schema.oneOf([Yup.ref('adminPassword')], "Password and Password Confirm didn't match"),
        }).label('Confirm Password'),
    }),    
]

const inits: ICreateAccount = {
    companyName: '', 
    companyOverseas: false,
    companyRegistration: '', 
    companyAddress: '', 
    companyTelephone: '', 
    companyFax: '', 
    companyWebsite: '', 
    adminName: '', 
    adminDesignation: '', 
    adminContact: '', 
    adminEmail: '', 
    adminPassword: '', 
    adminPasswordConfirm: '', 
}

export {createAccountSchemas, inits}
